import { getCurrentLocale } from '@/i18n';
import { capitalize } from 'lodash';
import { guideList, tourTypeList } from '@/constants';

const currentLanguage = getCurrentLocale();
const langCapitalize = capitalize(currentLanguage);

export function useConvertTextComposable() {
  const handleReplaceNameToValue = (value: string, field: string) => {
    if (field === 'tourType') {
      return tourTypeList.find((tourType: any) => tourType[`name${langCapitalize}`] === value)?.value;
    }
    return guideList.find((guide: any) => guide[`name${langCapitalize}`] === value)?.value;
  };

  const handleReplaceValueToName = (value: string, field: string) => {
    if (field === 'tourType') {
      return tourTypeList.find((tourType: any) => tourType.value === value)?.[`name${langCapitalize}`];
    }
    return guideList.find((guide: any) => guide.value === value)?.[`name${langCapitalize}`];
  };

  return {
    handleReplaceNameToValue,
    handleReplaceValueToName
  };
}
